import React, { useEffect, useRef, useState } from "react";
import styles from '../styles/TechTestimonial.module.scss';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col'
import Card from 'react-bootstrap/Card';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CustomImage from "./CustomImage"; 
import fetchUtil from "../utils/fetchUtil";

interface Props {
  title: string,
  bgColor: string
  slug?: string;
  data?: any
}

const TechTestimonial: React.FC<Props> = ({ title, bgColor, slug, data }) => {
  const sliderRef = useRef<Slider>(null);
  const [testimonialData, setTestimonialData] = useState<any>({})
  const settings = {
    dotsClass: styles.sliderDots,
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
   
  };

  useEffect(() => {
    data
      ? setTestimonialData(data)
      : fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/${slug}`, 'GET', {}, '', false)
        .then((res: any) => setTestimonialData(res))
  }, [])

  return (
    testimonialData?.length > 0
      ? <div id="studenttestimonial" className={styles.studentTestSlider}>
          <Container>
            <Row>
              <h2 className="mb-5 text-center">{title}</h2>
            </Row>
            <div id="studentmm" className={styles.student}>
              <div className={styles.customContainer}>
              <Container>
                <Row className='justify-content-center'>
                  <Col xl={12} lg={12} md={10} sm={12} xs={12} className="position-relative">
                      <Slider {...settings} ref={sliderRef} className={styles.slider}>
                      {testimonialData.map((slide: any, index: number) => {
                          return (
                          <div key={index}>
                              <Card className={styles.stuTestCard}>
                              <div className={styles.overlay}></div>
                                  <Card.Body className={styles.cardBody}>
                                      <div className={styles.testimonialImage}>
                                           <CustomImage  height={180} width={140} src={slide?.testimonial?.image?.url} alt={slide?.testimonial?.image?.alternativeText}/>
                                      </div>
                                      <div className={styles.testimonialDetail}>
                                          <svg width="33" height="22" viewBox="0 0 33 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path fillRule="evenodd" clipRule="evenodd" d="M0.0267741 14.2441C0.0232465 14.3384 0.0214669 14.4331 0.0214669 14.5283C0.0214665 18.6548 3.36666 22 7.49316 22C11.6197 22 14.9648 18.6548 14.9648 14.5283C14.9648 10.4018 11.6197 7.05662 7.49316 7.05662C6.73028 7.05662 5.99411 7.17095 5.30084 7.38341C6.8185 4.06918 11.3775 1.11242 13.5805 1.32304e-05C2.06855 2.26919 -0.255979 10.4465 0.0207498 14.2516L0.0267741 14.2441Z" fill="#FDAF4D" />
                                          <path fillRule="evenodd" clipRule="evenodd" d="M18.0492 14.2439C18.0457 14.3382 18.0439 14.4331 18.0439 14.5283C18.0439 18.6548 21.3891 22 25.5156 22C29.6421 22 32.9873 18.6548 32.9873 14.5283C32.9873 10.4018 29.6421 7.05662 25.5156 7.05662C24.7527 7.05662 24.0164 7.17097 23.3231 7.38347C24.8408 4.06924 29.3998 1.11247 31.6028 6.47288e-05C20.0908 2.26924 17.7663 10.4466 18.043 14.2516L18.0492 14.2439Z" fill="#FDAF4D" />
                                          </svg>
                                          <p>{slide?.testimonial?.message}</p>
                                          <h5 className="mb-0">{slide?.testimonial?.name}</h5>
                                          <div className={styles.addre}>
                                          <span>{slide?.testimonial?.details}</span>
                                          <br />
                                          <span>{slide?.testimonial?.subDetails}</span>
                                          </div>
                                      </div>
                                  </Card.Body>
                              </Card>
                          </div>
                          )
                      })}
                      </Slider>
                      <div className={styles.arrowsClass}>
                        <div className={styles.btcircle} onClick={() => sliderRef?.current?.slickPrev()}>
                          <CustomImage src='/new-images/right-arrow.svg' height={17} width={10} alt={"right-arrow"} />
                        </div>
                        <div className={styles.btcircle} onClick={() => sliderRef?.current?.slickNext()}>
                          <CustomImage src='/new-images/left-arrow.svg' height={17} width={10} alt={"left-arrow"} />
                        </div>
                      </div>
                    </Col>
                      
                </Row>
              </Container>
              </div>
            </div>
          </Container>
      </div>
      : null
  )
}
export default TechTestimonial;